import styles from './UserInfo.module.scss';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import { RootState } from 'redux/store';
import { Button } from 'ui/Button';
import doc from './img/iconDocFolder.svg';
import { ModalProfile } from 'components/ModalProfile';
import { useState, type FC } from 'react';
import { Avatar } from 'components/Avatar';
import { useCanManage } from 'hooks/useCanManage';
import { useGetProfileQuery } from 'redux/Api/profileApi/ProfileApi';
import { UserInfoResponse } from 'redux/Api/profileApi/type';
import { ModalConclusion } from 'components/ModalConclusion';

interface UserInfoTypes {
  close?: () => void;
  userData?: UserInfoResponse;
}

export const UserInfo: FC<UserInfoTypes> = ({ close, userData }) => {
  const navigate = useNavigate();
  const canManage = useCanManage();

  const { data, isLoading } = useGetProfileQuery();

  const [showModalProfile, setShowModalProfile] = useState(false);
  const [showModalConclusion, setShowModalConclusion] = useState(false);
  const { balance, name, hold, avatar } = useSelector(
    (state: RootState) => state.authSlice,
  );

  if (isLoading) return null;

  const isSigned = data?.beneficiary?.document?.is_signed;

  const getUserRoleForCompany = () => {
    if (!userData?.roles || !data?.id) return 'Администратор';

    const companyId = data.id;
    const employeeRole = `employee-${companyId}`;

    const hasEmployeeRole = userData.roles.some((role: string) => role === employeeRole);

    return hasEmployeeRole ? 'Сотрудник' : 'Администратор';
  };

  return (
    <div className={styles.root}>
      {isSigned ? (
        <div className={styles.root_info}>
          <div className={styles.root_info_wrapper}>
            <div className={styles.root_info_wrapper_mobile}>
              <div className={styles.root_info__balance_block}>
                <p className={styles.root_info__balanceTitle}>Баланс</p>
                <p className={styles.root_info__balance}>
                  {balance ? addSpaceNumber(balance) : 0}
                </p>
              </div>
              {canManage && (
                <Button
                  theme='outlineWhite'
                  size='S'
                  onClick={() => {
                    setShowModalConclusion(true);
                  }}>
                  Возврат
                </Button>
              )}
              <div className={styles.root_info__column}>
                <p className={styles.root_info__subtitle}>Зарезервировано</p>
                <p className={styles.root_info__hold}>
                  {hold ? addSpaceNumber(hold) : 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.root_info}>
          <p className={styles.root_info__alt}>Для начала работы - прими оферту</p>
          <Button
            icon
            src={doc}
            className={styles.btnAlt}
            onClick={() => {
              navigate('/profile');
              close?.();
            }}
            theme='filed'>
            Подписать оферту
          </Button>
        </div>
      )}

      <div className={styles.divider} />
      <div className={styles.root_profile}>
        <Link to='/profile'>
          <div style={{ display: 'flex' }}>
            <div className={styles.root_avatar}>
              {avatar ? (
                <img className={styles.avatar} src={avatar} alt={name} />
              ) : (
                <Avatar
                  avatar={avatar}
                  statusActive=''
                  id={1}
                  name={name}
                  height={'40px'}
                  width={'40px'}
                />
              )}
            </div>
            <div className={styles.root_profile__name}>
              <p>{name}</p>
              <span>{getUserRoleForCompany()}</span>
            </div>
          </div>
        </Link>
      </div>
      {showModalProfile && (
        <ModalProfile
          showModalProfile={showModalProfile}
          title='ООО "Рога и Копыта"'
          ls='123456789'
          setShowModalProfile={setShowModalProfile}
          avatar=''
          sum='123'
        />
      )}
      {showModalConclusion && (
        <ModalConclusion setShowModalConclusion={setShowModalConclusion} />
      )}
    </div>
  );
};
